export default __webpack_public_path__ + "static/media/logo_mjb.07400e65.png";